<template>
    <div class="">
        <div class="page-top mb-1 mb-3 clearfix">
			<ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
				<li class="nav-item">
                    <router-link to="/employees" id="complete-profile-tab" data-toggle="tab" class="nav-link" role="tab" aria-controls="complete-profile" aria-selected="true"> Complete Profile ({{complete_profile_count}})</router-link>
				</li>
				<li class="nav-item">
                    <router-link to="/incompleteEmployees" id="incomplete-profile-tab" data-toggle="tab" class="nav-link active" role="tab" aria-controls="incomplete-profile" aria-selected="true"> Incomplete Profile ({{incomplete_profile_count}})</router-link>
				</li>
			</ul>
            <router-link to="/addEmployeeBasicDetail" class="btn btn-primary float-right"> Add Employee</router-link>
			<a href="#" class="btn btn-primary float-right mr-1"> Employee Bulk Upload </a>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
		</div>
        <div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
				<div class="table-holder">
                    <table id="dt-complete-profile" class="table table-responsive-xl" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Phone Number</th>
                                <th>Status</th>
                                <th>Gross Pay</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                complete_profile_count : '',
                incomplete_profile_count : '',
            };
        },
        mounted() {
            this.$Progress.start();
            var incompleteTable = $('#dt-complete-profile').DataTable({
                "sDom": '<"row view-filter"<"clearfix">>t<"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                processing: true,
                serverSide: true,
                ajax: {
                    "url": "api/listIncompleteEmployees",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'name'},
                    {render: function(data,type,full){
                        if(full.designation != null){
                            return full.designation.name;
                        }
                    }},
                    {data: 'mobile_no'},
                    {data: 'status'},
                    {data: 'net_salary'},
                    {data: 'id', sorting: false, render: function(data,type,full){
                        var $url = '/editEmployee/'+full['id'];
                        return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a></td>';
                        // return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" >Edit</a>';
                    }}
                ],
                "order": [[ 0, "desc" ]],
                "initComplete": (settings, json) => {
                    this.complete_profile_count = json.completeCount;
                    this.incomplete_profile_count = json.recordsFiltered;
                    this.$Progress.finish();
                }
            });
            $('#customSearch').on( 'keyup', function () {
                incompleteTable.search(this.value).draw();
            });
        },
        created() {
            //
        }
    }
</script>
